import { useState, useEffect, useCallback } from "react";
import { apiClient } from "../lib/api";

export function useNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await apiClient.get("/notifications");
      setNotifications(data);
    } catch {
      // Own notifications should always be readable while authenticated; swallow to avoid
      // an unhandled-rejection crash on a transient network/auth blip.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const markRead = async (id) => {
    await apiClient.post(`/notifications/${id}/read`);
    load();
  };

  return { notifications, loading, markRead, reload: load };
}
